import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

export function useExpenses(params = {}) {
  return useQuery({
    queryKey: ['finance', 'expenses', params],
    queryFn: async () => {
      const { data } = await api.get('/finance/expenses', { params });
      return data;
    },
    staleTime: 15_000
  });
}

export function useCreateExpense() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ body, attachment }) => {
      const fd = new FormData();
      Object.entries(body).forEach(([k, v]) => {
        if (v == null) return;
        fd.append(k, typeof v === 'object' ? JSON.stringify(v) : String(v));
      });
      if (attachment) fd.append('attachment', attachment);
      return api
        .post('/finance/expenses', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then((r) => r.data);
    },
    successMessage: 'تم تسجيل المصروف',
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['finance', 'expenses'] });
      qc.invalidateQueries({ queryKey: ['finance', 'stats'] });
      qc.invalidateQueries({ queryKey: ['cashbox'] });
    }
  });
}

export function useUpdateExpense() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ id, body }) => api.patch(`/finance/expenses/${id}`, body).then((r) => r.data),
    successMessage: 'تم حفظ التعديلات',
    onSuccess: () => qc.invalidateQueries({ queryKey: ['finance', 'expenses'] })
  });
}
